import axios from 'axios'
import { baseUrl, metricUrl } from '@/api/config'
import { errorCollection } from '@/api/dmp/dmpCollection'

// 新增电子围栏
export function geofenceSave(params) {
  const url = metricUrl + '/geofence/save'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('电子围栏', '新增电子围栏', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询电子围栏详情信息
export function geofenceList(params) {
  const url = metricUrl + '/geofence/message'
  return axios({
    method: 'post',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('电子围栏', '查询电子围栏详情信息', res)
    }
    return Promise.resolve(res.data)
  })
}

// 删除电子围栏
export function geofenceDelete(params) {
  const url = metricUrl + '/geofence/delete/' + params.geofenceId
  return axios({
    method: 'delete',
    url: url,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('电子围栏', '删除电子围栏', res)
    }
    return Promise.resolve(res.data)
  })
}

// 编辑电子围栏
export function geofenceUpdate(params) {
  const url = metricUrl + '/geofence/update'
  return axios({
    method: 'put',
    url: url,
    data: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('电子围栏', '编辑电子围栏', res)
    }
    return Promise.resolve(res.data)
  })
}

// 查询组织树
export function getOus(params) {
  const url = baseUrl + '/orgunit/tree'

  return axios({
    method: 'get',
    url: url,
    params: params,
  }).then(res => {
    if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
      errorCollection('电子围栏', '查询组织树', res)
    }
    return Promise.resolve(res.data)
  })
}

// 获取地图中心点
export function getMapCenter() {
  const url = baseUrl + '/tenant/config/center/find'
  return axios({
    method: 'get',
    url: url,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('电子围栏', '获取地图中心点', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}

// 设置地图中心点
export function updateMapCenter(params) {
  const url = baseUrl + '/tenant/config/update/center'
  return axios({
    method: 'post',
    url: url,
    data: params,
  })
    .then(res => {
      if (res.status !== 200 || (!!res.data && res.data.state !== 0)) {
        errorCollection('电子围栏', '设置地图中心点', res)
      }
      return Promise.resolve(res.data)
    })
    .catch(err => {
      console.log(err)
    })
}
